/** What sort of place a business is (ADR 0008). A gym business is a club, never a "gym". */
export enum BusinessKind {
  /** People you book, alone or as a small team: a trainer, a dietician, a physio practice. */
  PRACTICE = "practice",
  /** A gym or fitness club: a place you go to. */
  CLUB = "club",
}

/** What a specialist does. One person can hold several; the free-text title stays for display. */
export enum SpecialistProfession {
  TRAINER = "trainer",
  DIETICIAN = "dietician",
  PHYSIO = "physio",
}

/**
 * What a service is (ADR 0030). A service has one or more, and the people who deliver it are
 * what the category makes them: delivering a physio service is what puts someone on the physio
 * page of the directory.
 */
export enum ServiceCategory {
  TRAINING = "training",
  DIET = "diet",
  PHYSIO = "physio",
}

/** The profession a category's services make the people who deliver them. */
export const CATEGORY_PROFESSION: Record<ServiceCategory, SpecialistProfession> = {
  [ServiceCategory.TRAINING]: SpecialistProfession.TRAINER,
  [ServiceCategory.DIET]: SpecialistProfession.DIETICIAN,
  [ServiceCategory.PHYSIO]: SpecialistProfession.PHYSIO,
};

/**
 * The colors a service or event can carry, in the picker's order: around the wheel, then the
 * neutrals. Stored by name; each app paints them from its `--service-*` tokens.
 */
export const BOOKING_COLORS = [
  "red",
  "orange",
  "yellow",
  "lime",
  "green",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "brown",
  "gray",
] as const;
export type BookingColor = (typeof BOOKING_COLORS)[number];
